























































































import { Auth } from '@finx/web-repository/src/services/Oidc'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import LogoutConfigStore from '@/store/LogoutConfigStore'
import { anonymizeEmail } from '@/utils/anonymizeEmail'

type UserReportDataProps = {
  token?: string;
  userData?: any;
  userAgent?: string;
  userAgentData?: any;
  from?: string;
}

@Component
export default class ViewNoContent extends Vue {
  showUserReportModal = false
  userReportData: UserReportDataProps = {}

  get logoutConfigStore() {
    return getModule(LogoutConfigStore, this.$store)
  }

  get emailAnonymized() {
    const USER_REPORT_KEY = `${window.API_FINX_AUTH}:finx:front-user-report`
    const userReportLocalStorage = localStorage.getItem(USER_REPORT_KEY)
    const userReport = JSON.parse(userReportLocalStorage || '{}')
    const validKeys = 'token' in userReport && 'profile' in userReport.token && 'email' in userReport.token.profile
    if (!validKeys) return ''
    const email = userReport.token.profile.email || ''
    
    return anonymizeEmail(email)
  }

  get errorMessage() {
    const USER_REPORT_KEY = `${window.API_FINX_AUTH}:finx:front-user-report`
    const userReportLocalStorage = localStorage.getItem(USER_REPORT_KEY)
    const userReport = JSON.parse(userReportLocalStorage || '{}')
    return userReport.message || ''
  }


  async inicio() {
    const user = await Auth.getUser()
    if (user && user.access_token) {
      await this.logoutConfigStore.authLogout(user.id)
    }
    window.location.href = '/inicio'
  }

  showUserReport() {
    const USER_REPORT_KEY = `${window.API_FINX_AUTH}:finx:front-user-report`
    this.showUserReportModal = true
    const userReportLocalStorage = localStorage.getItem(USER_REPORT_KEY)
    this.userReportData = {
      userAgent: window.navigator.userAgent,
      // @ts-ignore
      userAgentData: JSON.stringify(window.navigator ? window.navigator.userAgentData : ''),
      // @ts-ignore
      from: (window.navigation && window.navigation.activation && window.navigation.activation.from) ? window.navigation.activation.from.url : '',
      ...JSON.parse(userReportLocalStorage || ''),
    }
  }

  onClose() {
    this.showUserReportModal = false
  }
}
